import {mapTradeTagWriteToDb, TradeTag, TradeTagWrite} from '@cp/model';
import {addDoc} from 'firebase/firestore';
import {getCurrentUserIdValidated} from '../../config/firebase';
import {getTradeTagsCollection} from './getTradeTagsCollection';

export async function createTradeTag(input: TradeTagWrite): Promise<TradeTag> {
  const uid = await getCurrentUserIdValidated();
  const colRef = getTradeTagsCollection(uid);
  const parsed = mapTradeTagWriteToDb(input);
  const ref = await addDoc(colRef, parsed);
  return {id: ref.id, ...parsed};
}
